import classNames from 'classnames';
import RicosViewer from '../ricos-viewer/ricos-viewer';
import React, { useMemo } from 'react';
import { Node_Type } from '@wix/ricos';
import { RequiredIndicator, RequiredIndicatorPlacement as Placement } from '@wix/ambassador-forms-v4-form/types';
import { useTranslation } from '../../contexts/translation-context';
import { useRicosTheme } from '../../theme/ricos-theme-utils';
import styles from './field-rich-label.module.scss';
import cloneDeep from 'lodash/cloneDeep';
function requiredIndicatorText(requiredIndicatorType, t) {
  switch (requiredIndicatorType) {
    case RequiredIndicator.ASTERISK:
      return '*';
    case RequiredIndicator.TEXT:
      return t('settings.required-indicator-text');
    default:
      return '';
  }
}
export const FieldRichLabel = _ref => {
  let {
    label,
    required,
    disabled,
    requiredIndicatorType = RequiredIndicator.ASTERISK,
    requiredIndicatorPlacement = Placement.AFTER_FIELD_TITLE,
    ricosTheme
  } = _ref;
  const customTheme = useRicosTheme(ricosTheme);
  const {
    t
  } = useTranslation();
  const indicator = requiredIndicatorText(requiredIndicatorType, t);
  const labelWithIndicator = useMemo(() => {
    var _result$nodes;
    if (!required) {
      return label;
    }
    const str = v => ({
      stringValue: v
    });
    const indicatorNode = {
      type: Node_Type.EXTERNAL,
      id: '',
      nodes: [],
      externalData: {
        fields: {
          'aria-hidden': str('true'),
          className: str(styles.indicator)
        }
      },
      textData: {
        text: indicator,
        decorations: []
      }
    };
    const result = cloneDeep(label);
    switch (requiredIndicatorPlacement) {
      case Placement.BEFORE_FIELD_TITLE:
        const firstNode = result == null ? void 0 : result.nodes.find(Boolean);
        if (firstNode) {
          firstNode.nodes ??= [];
          firstNode.nodes.unshift(indicatorNode);
        }
        break;
      case Placement.AFTER_FIELD_TITLE:
        const lastNode = result == null || (_result$nodes = result.nodes) == null ? void 0 : _result$nodes.findLast(Boolean);
        if (lastNode) {
          lastNode.nodes ??= [];
          lastNode.nodes.push(indicatorNode);
        }
        break;
    }
    return result;
  }, [label, indicator, required, requiredIndicatorPlacement]);
  return useMemo(() => /*#__PURE__*/React.createElement(RicosViewer, {
    content: labelWithIndicator,
    className: classNames({
      [styles.disabled]: disabled,
      [styles.indicatorBeforeLabel]: requiredIndicatorPlacement === Placement.BEFORE_FIELD_TITLE,
      [styles.indicatorAfterLabel]: requiredIndicatorPlacement === Placement.AFTER_FIELD_TITLE
    }),
    customTheme: customTheme
  }), [disabled, requiredIndicatorPlacement, labelWithIndicator, customTheme]);
};
//# sourceMappingURL=field-rich-label.js.map